import {UpdateUserManagementProfileBody} from "@project/sdk/user-management/zod";
import type {z} from "zod";
import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {userManagementUserFieldLabelIds} from "../../../messages/user-management-users.messages";

export const updateUserManagementProfileFormSchema = UpdateUserManagementProfileBody.extend({
  displayName: requiredStringSchema(
    UpdateUserManagementProfileBody.shape.displayName,
    userManagementUserFieldLabelIds.displayName,
  ),
});
export type UpdateUserManagementProfileFormPayload = z.output<
  typeof updateUserManagementProfileFormSchema
>;
export const draftUpdateUserManagementProfileFormSchema =
  updateUserManagementProfileFormSchema.partial();
export type DraftUpdateUserManagementProfileFormPayload = z.output<
  typeof draftUpdateUserManagementProfileFormSchema
>;
